const MONITORING_BASE_URL = 'https://tophamtechbeb.com/aw-monitor/v1';

export const VISITOR_ANALYTICS_RANGES = ['7d', '30d', '120d'];

export const getWebsiteVisitors = async ({
  user,
  range = '30d',
  limit = 50,
  signal
} = {}) => {
  if (!VISITOR_ANALYTICS_RANGES.includes(range)) {
    throw new Error('Unsupported analytics date range.');
  }
  if (!Number.isInteger(limit) || limit < 1 || limit > 100) {
    throw new Error('Website visitor limit must be between 1 and 100.');
  }
  if (!user?.token) {
    throw new Error('Your session is missing an authentication token. Please sign in again.');
  }

  const params = new URLSearchParams({ range, limit: String(limit) });
  const response = await fetch(
    `${MONITORING_BASE_URL}/analytics/website-visitors?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        Authorization: `${user.type || 'Bearer'} ${user.token}`
      },
      signal
    }
  );

  if (!response.ok) {
    let message = 'Website visitor analytics are temporarily unavailable.';
    try {
      const payload = await response.json();
      if (payload?.detail) message = payload.detail;
    } catch (error) {
      // Keep the safe fallback for non-JSON server errors.
    }
    throw new Error(message);
  }

  return response.json();
};
